module.exports = global["jQuery"] = require("-!/usr/src/cube/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 40
// module chunks = 48